<div class="auction-card" [class.withdraw-horse]="data.withdrawn_at != null">
  <div class="auction-card-img-wrap">
    <div class="card-img">
      <img
        [src]="
          data.image || '../../../../../../../assets/images/defualt-image.jpg'
        "
        alt="horse img"
      />
    </div>
    <div class="batch" *ngIf="showType">
      <span
        class="badge"
        [ngClass]="auctionType"
        *ngIf="auctionType == 'active'"
        data-translation-key="auction_active_auction"
      >
        <svg
          width="11"
          height="11"
          viewBox="0 0 11 11"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M10.6777 11H4.83398C4.65599 11 4.51172 10.8557 4.51172 10.6777V10.334C4.51172 9.97798 4.80025 9.68944 5.15625 9.68944V9.30414C5.15625 8.79397 5.57133 8.37889 6.0815 8.37889H9.43022C9.94039 8.37889 10.3555 8.79397 10.3555 9.30414V9.68944C10.7115 9.68944 11 9.97798 11 10.334V10.6777C11 10.8556 10.8556 11 10.6777 11ZM6.96665 7.09722C6.75245 7.38146 6.34829 7.43829 6.06405 7.22402C5.77973 7.00985 5.72299 6.60568 5.93716 6.32134L7.8766 3.74766C8.09087 3.46333 8.49494 3.40659 8.7792 3.62077C9.06353 3.83503 9.12035 4.23911 8.90609 4.52346L6.96665 7.09722ZM2.334 3.60618C2.11973 3.89042 1.71563 3.94725 1.43131 3.73298C1.14707 3.51881 1.09025 3.11473 1.30451 2.83038L3.24397 0.256726C3.45815 -0.027598 3.86231 -0.0844241 4.14657 0.12984C4.43081 0.344103 4.48763 0.748181 4.27337 1.03253L2.334 3.60618ZM3.74767 5.4785C3.27134 5.11956 2.91373 4.67385 2.69008 4.20454L4.94678 1.20984C5.45955 1.29552 5.98651 1.51631 6.46293 1.87534C6.93928 2.23428 7.29689 2.67999 7.52054 3.14921L5.26382 6.14409C4.75108 6.05841 4.22411 5.83751 3.74767 5.4785ZM2.87749 5.56242C3.02753 5.71533 3.18557 5.86196 3.35979 5.99329C3.53409 6.12456 3.71864 6.23606 3.90689 6.33822L3.48668 6.89589L2.45719 6.12018L2.87749 5.56242ZM2.06929 6.63488L3.09878 7.41059L1.15932 9.98436C0.945055 10.2687 0.540977 10.3254 0.256717 10.1112C-0.027607 9.89698 -0.0843477 9.4929 0.12983 9.20856L2.06929 6.63488Z"
          />
        </svg>
        {{ "auction.active_auction" | translate }}
      </span>

      <span
        class="badge"
        [ngClass]="auctionType"
        *ngIf="auctionType == 'previous'"
        data-translation-key="auction_previous_auction"
      >
        <svg
          width="9"
          height="9"
          viewBox="0 0 9 9"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0.731707 3.29268H0V7.46341C0 8.30488 0.695122 9 1.53659 9H7.46341C8.30488 9 9 8.30488 9 7.46341V3.29268H8.26829H0.731707ZM5.67073 4.84756C5.79878 4.70122 6.05488 4.71951 6.18293 4.84756C6.58537 5.21341 6.96951 5.57927 7.37195 5.96342C7.51829 6.10976 7.5 6.34756 7.37195 6.47561C7.0061 6.87805 6.64024 7.2622 6.2561 7.66463C6.10976 7.81098 5.87195 7.79268 5.7439 7.66463C5.59756 7.53659 5.61585 7.28049 5.7439 7.15244C6.01829 6.84146 6.31098 6.54878 6.58537 6.23781C6.27439 5.94512 5.96341 5.65244 5.65244 5.37805C5.5061 5.21342 5.52439 4.97561 5.67073 4.84756ZM4.20732 4.84756C4.33537 4.70122 4.59146 4.71951 4.71951 4.84756C5.12195 5.21341 5.5061 5.57927 5.90854 5.96342C6.05488 6.10976 6.03658 6.34756 5.90854 6.47561C5.54268 6.87805 5.17683 7.2622 4.79268 7.66463C4.64634 7.81098 4.40854 7.79268 4.28049 7.66463C4.13415 7.53659 4.15244 7.28049 4.28049 7.15244C4.55488 6.84146 4.84756 6.54878 5.12195 6.23781C4.81098 5.94512 4.5 5.65244 4.18902 5.37805C4.04268 5.21342 4.06098 4.97561 4.20732 4.84756ZM8.26829 2.56098H9V1.53659C9 0.713415 8.34146 0.0365854 7.51829 0V0.841463C7.51829 1.04268 7.35366 1.20732 7.15244 1.20732C6.95122 1.20732 6.78658 1.02439 6.78658 0.841463V0H2.26829V0.804878C2.26829 1.0061 2.10366 1.17073 1.90244 1.17073C1.70122 1.17073 1.53659 0.987805 1.53659 0.804878V0C0.695122 0 0 0.695122 0 1.53659V2.56098H0.731707H8.26829Z"
          />
        </svg>
        {{ "auction.previous_auction" | translate }}
      </span>
      <span
        class="badge"
        [ngClass]="auctionType"
        *ngIf="auctionType == 'upcoming'"
        data-translation-key="auction_upcoming_auction"
      >
        <svg
          width="9"
          height="9"
          viewBox="0 0 9 9"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0.731707 3.29268H0V7.46341C0 8.30488 0.695122 9 1.53659 9H7.46341C8.30488 9 9 8.30488 9 7.46341V3.29268H8.26829H0.731707ZM5.67073 4.84756C5.79878 4.70122 6.05488 4.71951 6.18293 4.84756C6.58537 5.21341 6.96951 5.57927 7.37195 5.96342C7.51829 6.10976 7.5 6.34756 7.37195 6.47561C7.0061 6.87805 6.64024 7.2622 6.2561 7.66463C6.10976 7.81098 5.87195 7.79268 5.7439 7.66463C5.59756 7.53659 5.61585 7.28049 5.7439 7.15244C6.01829 6.84146 6.31098 6.54878 6.58537 6.23781C6.27439 5.94512 5.96341 5.65244 5.65244 5.37805C5.5061 5.21342 5.52439 4.97561 5.67073 4.84756ZM4.20732 4.84756C4.33537 4.70122 4.59146 4.71951 4.71951 4.84756C5.12195 5.21341 5.5061 5.57927 5.90854 5.96342C6.05488 6.10976 6.03658 6.34756 5.90854 6.47561C5.54268 6.87805 5.17683 7.2622 4.79268 7.66463C4.64634 7.81098 4.40854 7.79268 4.28049 7.66463C4.13415 7.53659 4.15244 7.28049 4.28049 7.15244C4.55488 6.84146 4.84756 6.54878 5.12195 6.23781C4.81098 5.94512 4.5 5.65244 4.18902 5.37805C4.04268 5.21342 4.06098 4.97561 4.20732 4.84756ZM8.26829 2.56098H9V1.53659C9 0.713415 8.34146 0.0365854 7.51829 0V0.841463C7.51829 1.04268 7.35366 1.20732 7.15244 1.20732C6.95122 1.20732 6.78658 1.02439 6.78658 0.841463V0H2.26829V0.804878C2.26829 1.0061 2.10366 1.17073 1.90244 1.17073C1.70122 1.17073 1.53659 0.987805 1.53659 0.804878V0C0.695122 0 0 0.695122 0 1.53659V2.56098H0.731707H8.26829Z"
          />
        </svg>
        {{ "auction.upcoming_auction" | translate }}
      </span>
    </div>
    <ul
      class="view-and-favorite-area"
      *ngIf="showFavoriteButton && data.withdrawn_at == null"
    >
      <li>
        <a
          href="javascript:void(0)"
          (click)="onFavoriteClick($event)"
          [class.filled]="data?.in_user_wishlist"
        >
          <svg
            *ngIf="!data.in_user_wishlist"
            width="16"
            height="15"
            viewBox="0 0 16 15"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M8.00013 3.32629L7.32792 2.63535C5.75006 1.01348 2.85685 1.57317 1.81244 3.61222C1.32211 4.57128 1.21149 5.95597 2.10683 7.72315C2.96935 9.42471 4.76378 11.4628 8.00013 13.6828C11.2365 11.4628 13.03 9.42471 13.8934 7.72315C14.7888 5.95503 14.6791 4.57128 14.1878 3.61222C13.1434 1.57317 10.2502 1.01254 8.67234 2.63441L8.00013 3.32629ZM8.00013 14.8125C-6.375 5.31378 3.57406 -2.09995 7.83512 1.8216C7.89138 1.87317 7.94669 1.9266 8.00013 1.98192C8.05303 1.92665 8.10807 1.87349 8.16513 1.82254C12.4253 -2.10182 22.3753 5.31284 8.00013 14.8125Z"
            />
          </svg>
          <svg
            *ngIf="data.in_user_wishlist"
            width="16"
            height="15"
            viewBox="0 0 16 15"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M8.00013 3.32629L7.32792 2.63535C5.75006 1.01348 2.85685 1.57317 1.81244 3.61222C1.32211 4.57128 1.21149 5.95597 2.10683 7.72315C2.96935 9.42471 4.76378 11.4628 8.00013 13.6828C11.2365 11.4628 13.03 9.42471 13.8934 7.72315C14.7888 5.95503 14.6791 4.57128 14.1878 3.61222C13.1434 1.57317 10.2502 1.01254 8.67234 2.63441L8.00013 3.32629Z"
              fill="#062106"
            />
          </svg>
        </a>
      </li>
    </ul>
    <div *ngIf="data.withdrawn_at == null">
      <app-timer
        *ngIf="
          (auctionType == 'active' &&
            !data?.expired &&
            gradualEnding &&
            isFromCatalogue) ||
          (auctionType == 'active' && !isFromCatalogue && !gradualEnding) ||
          (isUpcomingTimer && auctionType == 'upcoming')
        "
        [endDate]="data?.extended_end_date"
        [startDate]="data?.auction_start_date"
        [currentDate]="data.current"
        [translations]="translations"
        [showProgressPar]="false"
        [topProgress]="true"
        [theme]="'timer-bg-beige card-style'"
        [countInUpcoming]="isUpcomingTimer"
        [auc_type]="auctionType"
        (loadData)="handleTimeEnded(data)"
      ></app-timer>
    </div>
  </div>
  <div class="auction-card-content">
    <div class="price-and-code-area mb-3" *ngIf="showHip">
      <p class="code" data-translation-key="horse_info_hip">
        <span> {{ "horse_info.hip" | translate }}{{ data.hip }} </span>
      </p>
    </div>
    <h6 class="d-flex flex-column justify-content-center">
      <p
        class="d-flex justify-content-between align-items-center horse-name-display"
      >
        {{ data.name | horseName : data.Dam }}
        <button
          *ngIf="data.withdrawn_at == null && data.has_update"
          type="button"
          class="info-button"
          [matTooltip]="data.update_content"
          matTooltipPosition="above"
          matTooltipClass="material-tooltip buyer-theme horse-updates auction-item-card-update"
          [matTooltipShowDelay]="300"
          [matTooltipHideDelay]="500"
          [attr.aria-label]="'Information about ' + data.update_content"
          (click)="
            $event.stopPropagation(); $event.preventDefault(); tooltip?.toggle()
          "
          #tooltip="matTooltip"
        >
          <i class="bi bi-info-circle"></i>
        </button>
      </p>

      <span class="info-value">{{
        showAuctionName ? (data?.auction?.name | localizedName) : ""
      }}</span>
    </h6>
    <div class="pedigree-info">
      <div class="info-row">
        <div class="info-label" data-translation-key="horse_info_sire">
          {{ "horse_info.sire" | translate }}:
        </div>
        <div class="info-value">{{ data.Sire }}</div>
      </div>
      <div class="info-row">
        <div class="info-label" data-translation-key="horse_info_dam">
          {{ "horse_info.dam" | translate }}:
        </div>
        <div class="info-value">{{ data.Dam }}</div>
      </div>
      <div class="info-row">
        <div class="info-label" data-translation-key="horse_info_born">
          {{ "horse_info.born" | translate }}:
        </div>
        <div class="info-value">
          {{ data.bornData | localDateTime : "shortDate" }}
        </div>
      </div>
    </div>
    <div class="price-and-code-area">
      <div
        class="card-body__actions__amounts"
        *ngIf="data.withdrawn_at == null"
      >
        <!-- Show Latest Bid / Highest Bid / Selling Price for previous auctions OR individually closed horses in active auctions -->
        <p
          class="price"
          *ngIf="shouldShowDisplayPrice && displayPriceLabelKey as priceLabel"
        >
          <span [attr.data-translation-key]="displayPriceLabelAttr">{{
            priceLabel | translate
          }}</span>
          <span>
            <strong>
              {{
                (displayPriceAmount ?? 0)
                  | customCurrency
                    : displayPriceCurrency
                    : locale
                    : "symbol"
                    : "1.0-0"
              }}</strong
            >
          </span>
        </p>
        <!-- Fallback for legacy data without display_price -->
        <p
          class="price"
          *ngIf="!shouldShowDisplayPrice && !isNoStatusStatus && (auctionType == 'previous' || isHorseClosed) && (data?.highest_bid_amount || (isRnaStatus && data?.bids_count > 0) || isPSStatus)"
        >
          <span
            data-translation-key="horse_info_selling_price"
            *ngIf="isPSStatus"
            >{{ "horse_info.selling_price" | translate }}</span
          >
          <span
            data-translation-key="horse_info_latest_bid"
            *ngIf="!isRnaStatus && !isPSStatus"
            >{{ "horse_info.latest_bid" | translate }}</span
          >
          <span data-translation-key="horse_info_highest_bid" *ngIf="isRnaStatus"
            >{{ "horse_info.highest_bid" | translate }}</span
          >

          <span>
            <strong>
              {{
                (isPSStatus ? data?.display_price?.amount : data?.highest_bid_amount) || 0
                  | customCurrency
                    : auction?.currency?.currency_code
                    : locale
                    : "symbol"
                    : "1.0-0"
              }}</strong
            >
          </span>
        </p>
        <!-- Show Current Bid only for active horses in active auctions (not individually closed) -->
        <p class="price" *ngIf="auctionType == 'active' && !isHorseClosed">
          <span data-translation-key="horse_info_current_bid">
            {{ "horse_info.current_bid" | translate }}</span
          >

          <span>
            <strong>
              {{
                data?.highest_bid_amount || 0
                  | customCurrency
                    : auction?.currency?.currency_code
                    : locale
                    : "symbol"
                    : "1.0-0"
              }}</strong
            >
          </span>
        </p>
        <p class="price" *ngIf="auctionType == 'upcoming'">
          <span data-translation-key="horse_info_starting_bid">
            {{ "horse_info.starting_bid" | translate }}
          </span>
          <span>
            <strong>
              {{
                data?.min_bid || 0
                  | customCurrency
                    : auction?.currency?.currency_code
                    : locale
                    : "symbol"
                    : "1.0-0"
              }}
            </strong>
          </span>
        </p>
      </div>
      <!-- Blocked/Suspended Status Button (for non-catalogue view) - shown on its own line -->
      <ng-container *ngIf="isBlockedOrSuspended && loggedIn && auctionType == 'active' && !isFromCatalogue && data.withdrawn_at == null">
        <div class="buyer-status-container mt-2">
          <button
            class="btn bid-btn blocked-suspended-btn"
            [class.blocked]="isBlocked"
            [class.suspended]="isSuspended"
            disabled
          >
            <ng-container *ngIf="isBlocked">
              <mat-icon class="status-icon">block</mat-icon>
              {{ 'buyer_status.blocked' | translate }}
            </ng-container>
            <ng-container *ngIf="isSuspended && !isBlocked">
              <mat-icon class="status-icon">pause_circle</mat-icon>
              {{ 'buyer_status.suspended' | translate }}
            </ng-container>
          </button>
        </div>
      </ng-container>

      <div
        class="author-and-btn-area border-top-0 mt-0 pt-0 d-grid"
        *ngIf="data.withdrawn_at == null && !isBlockedOrSuspended"
      >
        <a
          (click)="goToBidPage($event, data)"
          class="bid-btn"
          *ngIf="
            (auctionType == 'upcoming' &&
              !showRequestToBidButton &&
              !isFromCatalogue) ||
            (data.can_bid &&
              auctionType == 'active' &&
              !isHorseClosed &&
              !isFromCatalogue &&
              loggedIn)
          "
          data-translation-key="auction_place_bid"
        >
          {{ "auction.place_bid" | translate }}
        </a>
        <app-bid-now-button
          *ngIf="data.can_bid && auctionType == 'active' && !isHorseClosed && isFromCatalogue"
          [dir]="dir"
          [elementId]="data?.id"
          [slug]="data?.slug"
          [condition]="data.can_bid && auctionType == 'active' && !isHorseClosed"
          [translations]="translations"
          [terms]="{
            buyer_accepted: auction?.buyer_accepted_seller_terms,
            seller_terms: auction?.seller_terms,
            auction_id: auction?.id
          }"
          [classStyle]="'bid-btn'"
          [buyerStatus]="auction?.buyer_status"
          [sellerEmail]="auction?.seller_email"
        ></app-bid-now-button>
        <app-request-to-bid-button
          *ngIf="showRequestToBidButton"
          [loggedIn]="loggedIn"
          [auctionSettings]="auctionSettings"
          [translations]="translations"
          [horseDetails]="data"
          [aucType]="auctionType"
          [theme]="'request'"
          [terms]="{
            buyer_accepted: auction?.buyer_accepted_seller_terms,
            seller_terms: auction?.seller_terms
          }"
          (fetchData)="handleLoadData()"
          [isCatalogue]="isFromCatalogue"
          [buyerStatus]="auction?.buyer_status"
          [sellerEmail]="auction?.seller_email"
          [canBid]="data.can_bid && auctionType == 'active' && !isHorseClosed && isFromCatalogue"
        ></app-request-to-bid-button>
        <!--
        <button
          disabled
          class="btn sold-status"
          *ngIf="data.status == 'reserved'"
          data-translation-key="horse_info_reserved"
        >
          {{
            data?.status | translationsConvertKey : "horse_info"
          }}
        </button> -->
        <button
          disabled
          class="btn ps-status"
          *ngIf="isPSStatus"
          data-translation-key="horse_info_ps"
        >
          {{ "horse_info.ps" | translate }}
        </button>
        <button
          disabled
          class="btn sold-status"
          *ngIf="
            (isSoldStatus || showSoldFromOfferFallback) &&
            !isPSStatus
          "
          data-translation-key="horse_info_sold"
        >
          {{ "horse_info.sold" | translate }}
        </button>
        <button
          disabled
          class="btn rna-status"
          *ngIf="
            (isRnaStatus && auctionType !== 'previous') ||
            (auctionType == 'previous' &&
              isRnaStatus &&
              !horseOffers?.make_an_offer?.is_available &&
              horseOffers?.make_an_offer.time_window_days == 0)
          "
          data-translation-key="horse_info_rna"
        >
          {{ "horse_info.rna" | translate }}
        </button>
        <button
          disabled
          class="btn winner-status"
          *ngIf="isWinnerStatus"
          data-translation-key="horse_info_winner"
        >
          {{ "horse_info.winner" | translate }}
        </button>
        <button
          disabled
          class="btn unsold-status"
          *ngIf="
            (isUnSoldStatus && auctionType !== 'previous' && !isRnaStatus) ||
            (auctionType == 'previous' &&
              isUnSoldStatus &&
              !horseOffers?.make_an_offer?.is_available &&
              horseOffers?.make_an_offer.time_window_days == 0 &&
              !isRnaStatus)
          "
          data-translation-key="horse_info_unsold"
        >
          {{ "horse_info.unsold" | translate }}
        </button>

        <!-- Show Make Offer for previous auctions OR individually closed horses in active auctions -->
        <ng-container
          *ngIf="
            (auctionType == 'previous' || isHorseClosed) &&
            (isUnSoldStatus || isRnaStatus || isLegacyUnSoldFlag) &&
            !horseOffers?.make_an_offer?.item_has_accepted_offer &&
            horseOffers?.make_an_offer.time_window_days != 0
          "
        >
          <app-make-offer-btn
            class="mt-2"
            [isDisabled]="
              !horseOffers?.make_an_offer?.is_available &&
              horseOffers?.make_an_offer.time_window_days != 0
            "
            [translations]="translations"
            [dir]="dir"
            [horseId]="data?.id"
            [currencyLocal]="{ locale: locale, currency: auction?.currency }"
          ></app-make-offer-btn>
        </ng-container>
      </div>
      <button
        disabled
        class="Withdrawn-status w-100"
        *ngIf="data.withdrawn_at != null"
        data-translation-key="horse_info_withdrawn"
      >
        {{ "horse_info.withdrawn" | translate }}
      </button>
    </div>
    <div
      class="author-and-btn-area"
      *ngIf="data?.withdrawn_at == null && data?.seller?.user"
    >
      <ng-container *ngIf="data?.seller?.user">
        <a
          class="author-area"
          (click)="gotToSellerPage($event, data?.seller?.user?.id)"
        >
          <div class="author-img">
            <img
              [src]="
                data?.seller?.user?.profile_picture ||
                '/assets/images/defualt-image.jpg'
              "
              [alt]="data?.seller?.user?.name"
            />
          </div>
          <div class="author-content">
            <h6>{{ data?.seller?.user?.name }}</h6>
          </div>
        </a>
      </ng-container>
    </div>
  </div>
</div>
